function Shimmer() {
   return (
      <div className="shimmer__wrapper">
         <div className="shimmer"></div>
      </div>
   );
}

export default Shimmer;
